import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from '../greensock/SplitText';
import { isMobile, isTabletDown } from './isMobile';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
export function ThirdScene() {
    var textBlock = document.querySelector('.third-section__text-block');
    var header = document.querySelector('.header__container .grid-container');
    var summaries = document.querySelectorAll('.solution-summary');
    var headerWidth = header.clientWidth + header.getBoundingClientRect().left - textBlock.getBoundingClientRect().left - 16 - (window.innerWidth < 1201 ? 16 : 0);
    var containerWidth = textBlock.clientWidth;
    var computedStyle = getComputedStyle(textBlock);
    containerWidth -= (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight));
    var circle = document.querySelector('.hero-second-scene__circle-graphics');
    var circleDiv = document.querySelector('.hero-second-scene__circle-graphics > div');
    var circleSvg = document.querySelector('.hero-second-scene svg');
    var secondScene = document.querySelector('.hero-second-scene');
    if (!isTabletDown()) {
        gsap.timeline({
            immediateRender: false,
            scrollTrigger: {
                trigger: '.third-section',
                start: '-30% 50%',
                end: '0%',
                scrub: true
            }
        })
            .to('.hero__clip-container', .5, { autoAlpha: 0 })
            .to('.hero-second-scene__circle-graphics .circle-background', { duration: .5, autoAlpha: 0 }, '-=.5')
            .set('.hero-second-scene', { zIndex: 6 })
            .to(circleDiv, 1, {
                scale: 0.45,
                y: () => '-=' + Math.min(window.innerWidth * .15, circle.getBoundingClientRect().top + circle.clientHeight * .275 - header.clientHeight - 16),
                x: () => '-=2.5vw',
                rotate: '+=360',
            });
    }

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.hero-third-scene',
            start: 'top top',
            end: '100%',
            scrub: 1
        }
    });
    tl
        .to('.third-section', 1, { opacity: 1 })
        .to('.hero-third-scene', 1, { opacity: 0 })
        .to('.third-section__first-bg', 1, { opacity: 1 }, '-=0.7')
        .to(textBlock, 1, { top: () => Math.max(header.clientHeight + circle.clientHeight * .45 + 32, .42314 * window.innerHeight) })
        .addLabel('textStart', '-=.5');
    var lines = [];
    for (var j = 0; j < summaries.length; j++) {
        summaries[j].classList.add('active');
        var textSplit = new SplitText(summaries[j].children, { type: 'lines' });
        lines.push(textSplit.lines);
        tl
            .staggerFrom(textSplit.lines, .5, { marginTop: 75 }, .1, 'textStart');
    }

    /*let tl2 = gsap.timeline({
        scrollTrigger: {
            trigger: '.third-section',
            start: 'top top',
            end: '100%',
            scrub: 1
        }
    })
        .addLabel('start');
    //var arrPath = circleGraphic.find('.arrow-path');
    //var arrHead = circleGraphic.find('.marker-path')[0];
    //tl2.to(arrHead, 1, { motionPath: { path: arrPath, align: arrPath, alignOrigin: [.5,0], autoRotate: true } })
    tl2.to('.third-section__second-bg', 2, { opacity: 1 });
    tl2.to(circleSvg, 1.2, { x: '+=' + (headerWidth - circle.clientWidth * .45) / .45 }, 'start+=.1');
    //tl2.to('.third-section__text-block', 1.2, { x: '11vw' }, '-=1.9');*/

    var targetWidth = textBlock.clientWidth < 590 ? containerWidth : headerWidth;
    for (var j = 0; j < summaries.length; j++) {
        for (var i = 0; i < lines[j].length; i++) {
            var item = $(lines[j][i]);
            item.css('display', 'inline-block');
            var width = item.width();
            item.css('display', 'block');
            /*tl2.fromTo(item, .8, {
                x: 0
            }, {
                x: targetWidth - width
            }, 'start+=' + (.5 + .1 * i));*/
        }
        if (j > 0) {
            summaries[j].classList.remove('active');
        }
    }
    //tl2.to('.third-section__text-block h2 .first-row', 1.2, {x: '+=20vw'}, '-=1.9');
    //tl2.to('.third-section__text-block h2 .second-row', 1.2, {x: '+=19vw'}, '-=1.7');
    //tl2.to('.third-section__text-block .first-paragraph', 1.2, {x: '+=25vw'}, '-=1.5');
    //tl2.to('.third-section__text-block .second-paragraph', 1.2, {x: '+=19vw'}, '-=1.4');
    //tl2.to('.third-section__text-block .second-paragraph', 1.2, {x: '+=19vw'}, '-=1.4');
    //tl2.to('.third-section__text-block .btn-outline', 1.2, {x: '+=41vw'}, '-=1.2');

    let tl3 = gsap.timeline({
        scrollTrigger: {
            //trigger: '.third-section__second-scene',
            trigger: '.third-section',
            start: () => 'top top',
            end: () => '+=100%',
            scrub: 1,
        }
    });
    tl3.set('.fourth-section', { pointerEvents: 'auto', zIndex: 5 });
    tl3.to('.hero-second-scene__circle-graphics', 2, { y: '-60vw', pointerEvents: 'none' });
    if (isTabletDown()) {
        tl3.set('.third-section', { zIndex: 4, pointerEvents: 'none' });
        tl3.to('.third-section__text-block', 2, { y: '-125vw' }, '-=2');
    }
    else {
        tl3.to('.third-section__text-block', 2, { y: '-60vw' }, '-=2');
    }
    tl3.set('.hero-second-scene__circle-graphics', { autoAlpha: 0 });
    tl3.set('.third-section, .hero-third-scene', { pointerEvents: 'none' });
    tl3.from('.fourth-section__text-block > *', 1, {
        stagger: .2,
        opacity: 0,
        y: 32
    });
    //if (!isMobile()) {
    //    tl3.from('.fourth-section__text-block h2', 1, { opacity: 1, y: () => '-=100' }, '-=0.8');
    //} else {
    //    tl3.from('.fourth-section__text-block h2', 1, { opacity: 1, y: () => '-=50' }, '-=0.8');
    //}
    tl3.to('.third-section', 1, { autoAlpha: 0 });
}